module.exports = __webpack_public_path__ + "static/tv200-9246a3b99115222081a2b562dd17afca.svg";